import { useQuery } from '@tanstack/react-query';
import { fetchData } from '../../../utils';
import useSmartlook from '../../useSmartlook';

export function useClientQuery(enabled = false) {
  const { error } = useSmartlook();
  return useQuery<Client>({
    queryKey: ['client'],
    queryFn: async () => {
      try {
        const data = await fetchData('/client');
        return data as Client;
      } catch (e) {
        error('[useClientQuery][GET /client]', e);
        throw e;
      }
    },
    enabled,
  });
}

type MobilePhone = {
  mobilePhone: string;
  self: string;
  clientLink: string;
  updatePhoneLink: string;
  status: string;
};

type Email = {
  self: string;
  clientLink: string;
  updateEMailLink: string;
  email: string;
};

export type Client = {
  firstName: string;
  lastName: string;
  declaredAddress: {
    fullAddress: string;
    location1: string;
    location2: string;
    postalCode: string;
  };
  hasAttachments: boolean;
  hasOcrSession: boolean;
  has0penLoanApplication: boolean;
  id: number;
  number: string;
  identified: boolean;
  employer: {
    address?: string;
    name?: string;
    employmentStatus?: string;
    employmentDetail?: string;
  };
  status:
    | 'UNKNOWN'
    | 'REGISTERED'
    | 'IDENTIFIED'
    | 'DELETED'
    | 'VALIDATED'
    | 'ACTIVE'
    | 'NOT_IDENTIFIED'
    | 'BANK_ID';
  actualAddress: {
    fullAddress: string;
    location2: string;
    postalCode: string;
  };
  mobilePhoneVerified: boolean;
  mobilePhone?: MobilePhone;
  email?: Email;
  fullName: string;
  bankAccount?: string;
  personalId: string;
  identityDocumentId: string;
  dateOfBirth: string;
  age: number;
  identifiedBy:
    | 'BANK'
    | 'BANK_ID'
    | 'MANUAL'
    | 'ID_SERVICE'
    | 'BROKER'
    | 'EMAIL'
    | 'IMMEDIATE_TRANSFER'
    | 'FINTONIC'
    | 'PRESTALO'
    | 'NOT_IDENTIFIED';
  registeredBy:
    | 'WEB'
    | 'OFFLINE'
    | 'BROKER'
    | 'CALL_CENTER'
    | 'LEAD_GENERATOR'
    | 'WEB_OTHER_PRODUCT';
};
